import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["ui--live-form"]

  sendRefresh() {
    if (this.hasUiLiveFormOutlet) {
      this.uiLiveFormOutlet.refresh()
    }
  }
}
